
















































































import Vue from 'vue';
import { Type, AnyType, TextType, ObjectType, EnumType, ColorType, ColorSpaceRGB, ConstantExpression, isArray, isObject, DataTypes } from 'expangine-runtime';
import { TypeSettings } from '../../types/TypeVisuals';
import ExpressionBase from '../ExpressionBase';


export default ExpressionBase<ConstantExpression>().extend({
  name: 'ConstantEditor',
  data: () => ({
    editing: false,
    editValue: null,
    fullscreen: false,
  }),
  computed: {
    isFullscreen(): boolean {
      return this.$vuetify.breakpoint.mdAndDown || this.fullscreen;
    },
    isFullscreenToggleVisible(): boolean {
      return !this.$vuetify.breakpoint.mdAndDown;
    },
    invalid(): boolean {
      return this.isInvalid(this.value.value);
    },
    inputType(): Type | null {
      return this.requiredType || AnyType.baseType;
    },
    enumeratedType(): EnumType | null {
      return this.computedType instanceof EnumType
        ? this.computedType
        : this.requiredType instanceof EnumType
          ? this.requiredType
          : null;
    },
    enumeratedLabel(): string | null {
      const type = this.enumeratedType;
      if (!type) {
        return null;
      }

      for (const [label, value] of type.options.constants.entries()) {
        if (DataTypes.equals(value, this.value.value)) {
          return label;
        }
      }

      return null;
    },
    inputSettings(): TypeSettings | null {
      return this.registry.getTypeSettingsValidFor(this.inputType, this.pathSettings)
        ? this.pathSettings
        : this.inputType 
          ? this.registry.getTypeSettings(this.inputType)
          : null;
    },
  },
  methods: {
    toggleFullscreen() {
      this.fullscreen = !this.fullscreen;
    },
    isInvalid(value: any) {
      return !!(this.requiredType && !this.requiredType.isValid(value));
    },
    edit() {
      this.editValue = this.value.value;
      if (this.isInvalid(this.editValue) && this.requiredType && this.inputSettings) {
        this.editValue = this.requiredType.fromJson(this.inputSettings.defaultValue);
      }
      this.editing = true;
    },
    editSave() {
      if (isObject(this.editValue)) {
        this.editValue = DataTypes.copy(this.editValue);
      }
      this.value.value = this.editValue;
      this.editing = false;
      this.update();
    },
    editCancel() {
      this.editing = false;
    },
  },
});
